export default __webpack_public_path__ + "static/media/Deed of Contract_00.ca1bb45d.jpg";